// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
import { ObjectSchema } from 'yup';
// Others
import { EMPTY_STRING, REG_EXP } from '~/utils/constants/common';
import { IClientContact } from '~/utils/interface/common';

export const schema = (t: TFunction): ObjectSchema<IClientContact> => {
  return yup.object().shape({
    id: yup.string().trim().optional(),
    email: yup
      .string()
      .trim()
      .test('isValidEmail', t('common_validate_invalid_email', { ns: 'common/base' }), (value) => {
        if (value && !REG_EXP.EMAIL.test(value)) return false;
        return true;
      })
      .optional(),
    countryCode: yup.string().optional(),
    phoneNumber: yup
      .string()
      .trim()
      .test('phone-length', t('common_validate_invalid_phone', { ns: 'common/base' }), (value) => {
        if (!value) return true;
        const phoneNumber = value?.replace(REG_EXP.NUMBER, EMPTY_STRING);
        return REG_EXP.PHONE_NUMBER.test(phoneNumber);
      })
      .optional(),
    firstName: yup
      .string()
      .trim()
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    contactType: yup.string().optional(),
    businessType: yup.string().optional(),
  });
};

export const defaultValues: IClientContact = {
  email: EMPTY_STRING,
};
